import styled from 'styled-components';
import { DownIcon } from 'assets/icons/withContainer';

export const DownSVG = styled(DownIcon)`
  rotate: -90deg;
`;
